// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"842bec86","239":"3b99f817","453":"bb95430a","667":"bfed2ea3"}[chunkId] + ".chunk.js";
};